import { StepPage, StepRenderProps } from 'containers/StepPage/StepPage';
import i18n from 'i18n';
import { useCallback } from 'react';
import { SiteAnnouncementSetupFlowPageModel } from './SiteAnnouncementSetupFlowPageModel';
import { SiteAnnouncementForm } from './SiteAnnouncementForm';
import { Redirect } from 'react-router-dom';
import { LoadingIndicator } from 'components/LoadingIndicator';
import { SiteAnnouncementSummary } from './SiteAnnouncementSummary';

export type SiteAnnouncementSetupFlowPageProps = {
  useModel: () => SiteAnnouncementSetupFlowPageModel;
};

export const SiteAnnouncementSetupFlowPage: React.FC<
  SiteAnnouncementSetupFlowPageProps
> = ({ useModel }) => {

  const {
    loading,
    title,
    redirectPath,
    siteAnnouncement,
    onSubmit,
    onCancel,
    validateForm,
    getFormConfig,
    setSiteAnnouncement
  } = useModel();

  const renderSetupStep = useCallback(
    ({ goNext }: StepRenderProps) => {
      return (
        <SiteAnnouncementForm
          siteAnnouncement={siteAnnouncement}
          goNext={goNext}
          onCancel={onCancel}
          validateForm={validateForm}
          getFormConfig={getFormConfig}
          setSiteAnnouncement={setSiteAnnouncement}
        />
      );
    },
    [
      siteAnnouncement,
      validateForm,
      getFormConfig,
      setSiteAnnouncement,
      onCancel
    ]
  );

  const renderSummaryStep = useCallback(
    ({ goLast }: StepRenderProps) => {
      if (!siteAnnouncement) {
        return <LoadingIndicator />;
      }
      return (
        <div>
          <SiteAnnouncementSummary
            siteAnnouncement={siteAnnouncement}
            goLast={goLast}
            onSubmit={onSubmit}
            onCancel={onCancel}
          />
        </div>
      );
    },
    [siteAnnouncement, onSubmit, onCancel]
  );

  if (redirectPath) {
    return <Redirect to={redirectPath} />;
  }

  return (
    <>
      {loading && <LoadingIndicator />}
      <StepPage
        title={title}
        withSidebar={false}
        spaceBetweenTopAreaAndContent={false}
      >
        <StepPage.Step
          label={i18n.t<string>('siteAnnouncement.labels.setupStep')}
          renderStepContent={renderSetupStep}
        />
        <StepPage.Step
          label={i18n.t<string>('siteAnnouncement.labels.summaryStep')}
          renderStepContent={renderSummaryStep}
        />
      </StepPage>
    </>
  );
};
